import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=ed8cbec2&scoped=true&"
import script from "./AccordionList.vue?vue&type=script&lang=js&"
export * from "./AccordionList.vue?vue&type=script&lang=js&"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=ed8cbec2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8cbec2",
  null
  
)

export default component.exports